var React = require('react');

function SVGIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12.0825 19.5513C12.0825 17.3422 13.8734 15.5513 16.0825 15.5513H21.9434C22.9647 15.5513 23.9474 15.942 24.6899 16.6432L25.5574 17.4625C26.2999 18.1638 27.2825 18.5544 28.3038 18.5544H47.9176C50.1267 18.5544 51.9176 20.3453 51.9176 22.5544V43.6277C51.9176 45.8368 50.1267 47.6277 47.9176 47.6277H16.0826C13.8735 47.6277 12.0826 45.8368 12.0826 43.6277L12.0825 19.5513Z","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M51.0029 24.2358H13.4644","stroke":"currentColor","strokeLinecap":"round","strokeDasharray":"3 3","key":1})]);
}

SVGIcon.defaultProps = {"viewBox":"0 0 64 65"};

module.exports = SVGIcon;

SVGIcon.default = SVGIcon;
